import { __ } from '@wordpress/i18n'

export default { makeAppointment: __('Termin vereinbaren', 'dhsv_theme') }
